import './ApiActivityType.js';
import './ApiAdditionalInfoType.js';
import './ApiAirportType.js';
import './ApiAvailState.js';
import './ApiBaggageType.js';
import './ApiBaggageUnitType.js';
import './ApiBaseDataSource.js';
import { ApiBestPricePackageModelFromJSONTyped } from './ApiBestPricePackageModel.js';
import { ApiBestPriceRoomFromJSONTyped } from './ApiBestPriceRoom.js';
import { ApiBookedItemFromJSONTyped } from './ApiBookedItem.js';
import { ApiBookingFromJSONTyped } from './ApiBooking.js';
import './ApiBookingAction.js';
import './ApiBookingState.js';
import { ApiBusItemFromJSONTyped } from './ApiBusItem.js';
import { ApiBusUnitFromJSONTyped } from './ApiBusUnit.js';
import './ApiCabinClass.js';
import { ApiCamperFromJSONTyped } from './ApiCamper.js';
import { ApiCamperExtraFromJSONTyped } from './ApiCamperExtra.js';
import './ApiCamperFeatureType.js';
import { ApiCamperRateFromJSONTyped } from './ApiCamperRate.js';
import { ApiCamperSpecialOfferFromJSONTyped } from './ApiCamperSpecialOffer.js';
import { ApiCaptureDataFromJSONTyped } from './ApiCaptureData.js';
import { ApiCarRateFromJSONTyped } from './ApiCarRate.js';
import './ApiClientType.js';
import { ApiComponentFromJSONTyped } from './ApiComponent.js';
import './ApiComponentPriceType.js';
import './ApiComponentType.js';
import './ApiConfigurationDataType.js';
import './ApiDebitType.js';
import { ApiDepositPaymentDataFromJSONTyped } from './ApiDepositPaymentData.js';
import './ApiDirection.js';
import './ApiDistanceUnit.js';
import './ApiDocumentSubType.js';
import './ApiDocumentType.js';
import './ApiDurationType.js';
import { ApiExtraServiceFromJSONTyped } from './ApiExtraService.js';
import { ApiExtraUnitFromJSONTyped } from './ApiExtraUnit.js';
import { ApiFareFromJSONTyped } from './ApiFare.js';
import './ApiFilterCategory.js';
import './ApiFilterType.js';
import { ApiFinalPaymentDataFromJSONTyped } from './ApiFinalPaymentData.js';
import { ApiFlightFareFromJSONTyped } from './ApiFlightFare.js';
import { ApiFlightItemFromJSONTyped } from './ApiFlightItem.js';
import { ApiFlightLegFromJSONTyped } from './ApiFlightLeg.js';
import { ApiFlightRouteFromJSONTyped } from './ApiFlightRoute.js';
import { ApiFlightSegmentFromJSONTyped } from './ApiFlightSegment.js';
import './ApiFuelType.js';
import './ApiGender.js';
import { ApiHotelFromJSONTyped } from './ApiHotel.js';
import { ApiHotelRoomFromJSONTyped } from './ApiHotelRoom.js';
import './ApiImageType.js';
import { ApiInsuranceFromJSONTyped } from './ApiInsurance.js';
import { ApiInsuranceUnitFromJSONTyped } from './ApiInsuranceUnit.js';
import './ApiInventory.js';
import { ApiItemFromJSONTyped } from './ApiItem.js';
import './ApiItemType.js';
import './ApiNoteOriginType.js';
import './ApiNoteType.js';
import { ApiPackageModelFromJSONTyped } from './ApiPackageModel.js';
import './ApiPackagePriceComponentType.js';
import { ApiPaymentFromJSONTyped } from './ApiPayment.js';
import './ApiPaymentDataType.js';
import './ApiPaymentOption.js';
import './ApiPaymentState.js';
import './ApiPriceModifierType.js';
import './ApiPriceType.js';
import './ApiRecommendationServiceType.js';
import './ApiRelatedServiceRelationType.js';
import { ApiRentalCarFromJSONTyped } from './ApiRentalCar.js';
import './ApiRole.js';
import { ApiRoomRateFromJSONTyped } from './ApiRoomRate.js';
import { ApiRouteFromJSONTyped } from './ApiRoute.js';
import './ApiRowCharacteristics.js';
import { ApiSearchRouteFromJSONTyped } from './ApiSearchRoute.js';
import { ApiSeatFromJSONTyped } from './ApiSeat.js';
import './ApiSeatCharacteristics.js';
import { ApiServiceFromJSONTyped } from './ApiService.js';
import './ApiServiceSelectionType.js';
import { ApiServiceUnitFromJSONTyped } from './ApiServiceUnit.js';
import './ApiSortDirection.js';
import './ApiSortOption.js';
import './ApiSpecialRequestGroup.js';
import './ApiStaticContentType.js';
import './ApiTaxDisplay.js';
import { ApiTourFromJSONTyped } from './ApiTour.js';
import { ApiTransferFromJSONTyped } from './ApiTransfer.js';
import { ApiTransferUnitFromJSONTyped } from './ApiTransferUnit.js';
import './ApiTransmissionType.js';
import { ApiTravelDateCandidateFromJSONTyped } from './ApiTravelDateCandidate.js';
import './ApiTravelStatusEnum.js';
import { ApiTravelerPricingInfoFromJSONTyped } from './ApiTravelerPricingInfo.js';
import './ApiTravelerType.js';
import { ApiTripItemFromJSONTyped } from './ApiTripItem.js';
import { ApiUnitRateFromJSONTyped } from './ApiUnitRate.js';
import { ApiVoucherFromJSONTyped } from './ApiVoucher.js';
import './ApiVoucherDeliveryType.js';
import './ApiWalletType.js';

/* tslint:disable */
function ApiBaseModelFromJSON(json) {
    return ApiBaseModelFromJSONTyped(json, false);
}
function ApiBaseModelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['type'] === 'Booking') {
            return ApiBookingFromJSONTyped(json, true);
        }
        if (json['type'] === 'Item') {
            return ApiItemFromJSONTyped(json, true);
        }
        if (json['type'] === 'Route') {
            return ApiRouteFromJSONTyped(json, true);
        }
        if (json['type'] === 'Payment') {
            return ApiPaymentFromJSONTyped(json, true);
        }
        if (json['type'] === 'Component') {
            return ApiComponentFromJSONTyped(json, true);
        }
        if (json['type'] === 'TravelDateCandidate') {
            return ApiTravelDateCandidateFromJSONTyped(json, true);
        }
        if (json['type'] === 'DepositPaymentData') {
            return ApiDepositPaymentDataFromJSONTyped(json, true);
        }
        if (json['type'] === 'FinalPaymentData') {
            return ApiFinalPaymentDataFromJSONTyped(json, true);
        }
        if (json['type'] === 'CaptureData') {
            return ApiCaptureDataFromJSONTyped(json, true);
        }
        if (json['type'] === 'BookedItem') {
            return ApiBookedItemFromJSONTyped(json, true);
        }
        if (json['type'] === 'PackageModel') {
            return ApiPackageModelFromJSONTyped(json, true);
        }
        if (json['type'] === 'BusItem') {
            return ApiBusItemFromJSONTyped(json, true);
        }
        if (json['type'] === 'FlightItem') {
            return ApiFlightItemFromJSONTyped(json, true);
        }
        if (json['type'] === 'Fare') {
            return ApiFareFromJSONTyped(json, true);
        }
        if (json['type'] === 'TravelerPricingInfo') {
            return ApiTravelerPricingInfoFromJSONTyped(json, true);
        }
        if (json['type'] === 'ExtraUnit') {
            return ApiExtraUnitFromJSONTyped(json, true);
        }
        if (json['type'] === 'UnitRate') {
            return ApiUnitRateFromJSONTyped(json, true);
        }
        if (json['type'] === 'TripItem') {
            return ApiTripItemFromJSONTyped(json, true);
        }
        if (json['type'] === 'RentalCar') {
            return ApiRentalCarFromJSONTyped(json, true);
        }
        if (json['type'] === 'CarRate') {
            return ApiCarRateFromJSONTyped(json, true);
        }
        if (json['type'] === 'HotelRoom') {
            return ApiHotelRoomFromJSONTyped(json, true);
        }
        if (json['type'] === 'RoomRate') {
            return ApiRoomRateFromJSONTyped(json, true);
        }
        if (json['type'] === 'Service') {
            return ApiServiceFromJSONTyped(json, true);
        }
        if (json['type'] === 'ServiceUnit') {
            return ApiServiceUnitFromJSONTyped(json, true);
        }
        if (json['type'] === 'Camper') {
            return ApiCamperFromJSONTyped(json, true);
        }
        if (json['type'] === 'CamperRate') {
            return ApiCamperRateFromJSONTyped(json, true);
        }
        if (json['type'] === 'CamperExtra') {
            return ApiCamperExtraFromJSONTyped(json, true);
        }
        if (json['type'] === 'CamperSpecialOffer') {
            return ApiCamperSpecialOfferFromJSONTyped(json, true);
        }
        if (json['type'] === 'BestPricePackageModel') {
            return ApiBestPricePackageModelFromJSONTyped(json, true);
        }
        if (json['type'] === 'BestPriceRoom') {
            return ApiBestPriceRoomFromJSONTyped(json, true);
        }
        if (json['type'] === 'Seat') {
            return ApiSeatFromJSONTyped(json, true);
        }
        if (json['type'] === 'SearchRoute') {
            return ApiSearchRouteFromJSONTyped(json, true);
        }
        if (json['type'] === 'FlightRoute') {
            return ApiFlightRouteFromJSONTyped(json, true);
        }
        if (json['type'] === 'FlightFare') {
            return ApiFlightFareFromJSONTyped(json, true);
        }
        if (json['type'] === 'ExtraService') {
            return ApiExtraServiceFromJSONTyped(json, true);
        }
        if (json['type'] === 'Hotel') {
            return ApiHotelFromJSONTyped(json, true);
        }
        if (json['type'] === 'Tour') {
            return ApiTourFromJSONTyped(json, true);
        }
        if (json['type'] === 'Transfer') {
            return ApiTransferFromJSONTyped(json, true);
        }
        if (json['type'] === 'Insurance') {
            return ApiInsuranceFromJSONTyped(json, true);
        }
        if (json['type'] === 'Voucher') {
            return ApiVoucherFromJSONTyped(json, true);
        }
        if (json['type'] === 'BusUnit') {
            return ApiBusUnitFromJSONTyped(json, true);
        }
        if (json['type'] === 'TransferUnit') {
            return ApiTransferUnitFromJSONTyped(json, true);
        }
        if (json['type'] === 'InsuranceUnit') {
            return ApiInsuranceUnitFromJSONTyped(json, true);
        }
        if (json['type'] === 'FlightSegment') {
            return ApiFlightSegmentFromJSONTyped(json, true);
        }
        if (json['type'] === 'FlightLeg') {
            return ApiFlightLegFromJSONTyped(json);
        }
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'idParent': json['idParent'],
    };
}
function ApiBaseModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'type': value.type,
        'idParent': value.idParent,
    };
}

export { ApiBaseModelFromJSON, ApiBaseModelFromJSONTyped, ApiBaseModelToJSON };
//# sourceMappingURL=ApiBaseModel.js.map
